import { FC } from "react";

import { useFormatDate } from "src/internationalization";

const CSS_COLOR_CLASSES = {
  info: "bg-tagBackgroundBlue",
  warning: "bg-supportWarning",
  error: "bg-tagBackgroundRed",
  success: "bg-tagBackgroundGreen",
};

const DEFAULT_COLOR = CSS_COLOR_CLASSES.info;

export type TimelineEventType = "info" | "warning" | "error" | "success";

export type TimelineEventDetails = {
  type?: TimelineEventType;
  date: Date | null | undefined;
  isLast?: boolean;
  title: string;
};

type TimelineEventProps = TimelineEventDetails;
export const TimelineEvent: FC<TimelineEventProps> = ({ date, title, type, isLast }) => {
  const color = type ? CSS_COLOR_CLASSES[type] : DEFAULT_COLOR;
  const formatDate = useFormatDate();
  return (
    <div className="flex gap-5">
      <div className="flex flex-col items-center">
        <div>
          <div className={`${color} rounded-full w-5 h-5`} />
        </div>
        {!isLast && <div className="h-full border-borderSubtle01 border-l border-solid" />}
      </div>
      <div className="flex flex-col pb-5">
        <div className="text-sm">{title}</div>
        {date && (
          <div className="text-textSecondary text-xs">
            {formatDate(date, {
              timeStyle: "short",
              dateStyle: "medium",
            })}
          </div>
        )}
      </div>
    </div>
  );
};
